/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DadosContratoAliases {
  BUTTON_IMPRIMIR = 'button-imprimir',
  CARD_0 = 'card-0',
  CARD_1 = 'card-1',
  CARD_2 = 'card-2',
  CARD_3 = 'card-3',
  CARD_4 = 'card-4',
  CUSTOM_CARD_CPT = 'custom-card-cpt',
  CUSTOM_CARD_DADOS_CONTRATO = 'custom-card-dados-contrato',
  DASHBOARD_0 = 'dashboard-0',
  DECK_0 = 'deck-0',
  DECK_1 = 'deck-1',
  FETCH_0 = 'fetch-0',
  FETCH_1 = 'fetch-1',
  FETCH_2 = 'fetch-2',
  FETCH_4 = 'fetch-4',
  FETCH_CARD_ANS = 'fetch-card-ans',
  FETCH_CARD_OPERADORA = 'fetch-card-operadora',
  FETCH_COMPARTILHAMENTO_GESTAO_RISCOS = 'fetch-compartilhamento-gestao-riscos',
  FETCH_INFORMACOES_CONTRATUAIS = 'fetch-informacoes-contratuais',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_12 = 'field-12',
  FIELD_13 = 'field-13',
  FIELD_14 = 'field-14',
  FIELD_15 = 'field-15',
  FIELD_16 = 'field-16',
  FIELD_17 = 'field-17',
  FIELD_20 = 'field-20',
  FIELD_21 = 'field-21',
  FIELD_22 = 'field-22',
  FIELD_23 = 'field-23',
  FIELD_24 = 'field-24',
  FIELD_25 = 'field-25',
  FIELD_26 = 'field-26',
  FIELD_27 = 'field-27',
  FIELD_28 = 'field-28',
  FIELD_29 = 'field-29',
  FIELD_30 = 'field-30',
  FIELD_31 = 'field-31',
  FIELD_32 = 'field-32',
  FIELD_33 = 'field-33',
  FIELD_CONTRATO_COLETIVO = 'field-contrato-coletivo',
  FIELD_LIMITE_UTILIZACAO = 'field-limite-utilizacao',
  FIELD_LIST_0 = 'field-list-0',
  FIELD_SUB_ESTIPULANTE = 'field-sub-estipulante',
  FIELD_TITULAR = 'field-titular',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  FORM_2 = 'form-2',
  FORM_3 = 'form-3',
  FORM_4 = 'form-4',
  LAYOUT_DADOS_CONTRATO = 'layout-dados-contrato',
  LINK_EMAIL_ANS = 'link-email-ans',
  LINK_NUCLEOS_FISCALIZACAO = 'link-nucleos-fiscalizacao',
  LINK_SITE_ANS = 'link-site-ans',
  LINK_TELEFONE_ANS = 'link-telefone-ans',
  LINK_TELEFONE_OPERADORA = 'link-telefone-operadora',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  PANEL_5 = 'panel-5',
  PANEL_6 = 'panel-6',
  PANEL_COMPARTILHAMENTO_GESTAO_RISCOS = 'panel-compartilhamento-gestao-riscos',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_WITH_CONTENT_0 = 'tab-with-content-0',
  TAB_WITH_CONTENT_1 = 'tab-with-content-1',
  TAB_WITH_CONTENT_2 = 'tab-with-content-2',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
  TEXT_11 = 'text-11',
  TEXT_12 = 'text-12',
  TEXT_13 = 'text-13',
  TEXT_14 = 'text-14',
  TEXT_15 = 'text-15',
  TEXT_16 = 'text-16',
  TEXT_17 = 'text-17',
  TEXT_18 = 'text-18',
  TEXT_19 = 'text-19',
  TEXT_20 = 'text-20',
  TEXT_21 = 'text-21',
  TEXT_22 = 'text-22',
  TEXT_23 = 'text-23',
  TEXT_24 = 'text-24',
  TEXT_25 = 'text-25',
  TEXT_26 = 'text-26',
  TEXT_27 = 'text-27',
  TEXT_28 = 'text-28',
  TEXT_29 = 'text-29',
  TEXT_30 = 'text-30',
  TEXT_MSG_OPERADORA = 'text-msg-operadora',
}
export { DadosContratoAliases };
